const en = {
  home: 'home',
  showMore: 'SHOW MORE',
  inProgres: {
    title: 'PROJECT IN PROGRESS',
    p1: 'Construction of the residential-commercial building PROJECT BRDA has begun in a quiet location in the namesake neighborhood, which will be surrounded by greenery and accessible via a local access road. The ideal position of the apartments provides access to all amenities - schools, kindergartens, markets, green spaces, walking paths, shopping centers, clinics, and other facilities that can make your life easier, more dynamic, and exciting.',
    p2: 'A residential-commercial building is under construction, consisting of two levels of underground garages that will be directly connected to the apartments by an elevator, a ground floor, 4 floors, and an upper level with a total of 168 apartments. The offer includes studio, one-bedroom, two-bedroom, and three-bedroom apartments, as well as a penthouse with a beautiful rooftop terrace.',
    p3: 'Built from high-quality materials, the apartments meet the highest construction standards, featuring modern and sophisticated finishes that the buyer can personally select to make the space reflect their own personality and turn it into their new home.',
  },
  horizontalScroll: {
    appartments: 'APARTMENTS',
    garage: 'GARAGE SPOT',
    business: 'BUSINESS PREMISES',
    parking: 'OUTSIDE PARKING',
  },
  apartments: {
    name: {
      studio: 'GARSONJERA',
      one: 'JEDNOSOBNI STAN',
      two: 'DVOSOBNI STAN',
      three: 'TROSOBNI STAN',
      bp: 'POSLOVNI PROSTOR',
      penthouse:'NADGRAĐE',
    },
  },
  InProgressPage: {
    errorFilter:
      'Your search returned no results. Please adjust the filter criteria and try again.',
  },
};
export default en;
